import { render, staticRenderFns } from "./YellowButton.vue?vue&type=template&id=4003a885&scoped=true&"
import script from "./YellowButton.vue?vue&type=script&lang=js&"
export * from "./YellowButton.vue?vue&type=script&lang=js&"
import style0 from "./YellowButton.vue?vue&type=style&index=0&id=4003a885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003a885",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
